import { UntypedFormGroup } from '@angular/forms';

export function markControlsAsTouched(form: UntypedFormGroup): void {
  Object.keys(form.controls).forEach((key) => {
    form.controls[key].markAsTouched();
  });
}
